module.exports = __webpack_public_path__ + "img/server.d4a7ea39.svg";